import React, { useEffect, useMemo } from 'react';
import styles from './NotificationInToast.module.scss';
import Avatar from '../Avatar/Avatar';
import { getAvatarFromMessage, getMessageTitle } from '../../features/Notifications/utils';
import { stripHtmlTags } from '../../utils/stringHelper';
import Icon from '../Icon/Icon';

const NotificationInToast = ({ message, onClick, onCloseClick }) => {
  const { title, avatar, body } = useMemo(() => {
    const title = getMessageTitle(message);
    const avatar = getAvatarFromMessage(message);
    const body = stripHtmlTags(message.body);
    return { title, avatar, body };
  }, [message]);

  return (
    <div className={styles.wrapper}>
      <Avatar image={avatar} title={!avatar ? message.sender : ''} size="large" className={styles.userAvatar} onClick={onClick} />
      <div className={styles.contentWrapper} onClick={onClick}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.content}>{body}</p>
      </div>
      <div className={styles.closeButton}>
        <Icon src="close" className={styles.toastCloseIcon} />
      </div>
    </div>
  );
};

export default NotificationInToast;
